module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Settings#4-bb53fac9b75647c5c1c06b2b5b8c0e76.svg";